import { render, staticRenderFns } from "./DimensionFilterSummary.vue?vue&type=template&id=d1d5cb70&scoped=true"
import script from "./DimensionFilterSummary.vue?vue&type=script&lang=js"
export * from "./DimensionFilterSummary.vue?vue&type=script&lang=js"
import style0 from "./DimensionFilterSummary.vue?vue&type=style&index=0&id=d1d5cb70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1d5cb70",
  null
  
)

export default component.exports